import React from "react";

interface CloseIconProps {
	onClick: () => void;
	position?: { top?: string; right?: string; bottom?: string; left?: string };
  }
  
  const CloseIcon = ({ onClick, position }: CloseIconProps) => (
	<svg
	  style={position ? { position: 'absolute', ...position } : {}}
	  onClick={onClick}
	  width="30"
	  height="30"
	  viewBox="0 0 30 30"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	  cursor="pointer"
	>
	  <path d="M15.0001 0C6.71488 0 0 6.71488 0 15C0 23.2851 6.71488 30 15.0001 30C23.2851 30 30 23.2851 30 15C30 6.71488 23.2851 0 15.0001 0ZM20.0606 17.9393C20.6465 18.5252 20.6465 19.4745 20.0606 20.0604C19.4742 20.6468 18.5252 20.6462 17.9394 20.0604L15 17.121L12.0606 20.0604C11.4742 20.6468 10.5253 20.6462 9.93944 20.0604C9.3535 19.4745 9.3535 18.5252 9.93944 17.9393L12.8789 14.9999L9.93944 12.0606C9.3535 11.4746 9.3535 10.5254 9.93944 9.93944C10.5254 9.3535 11.4746 9.3535 12.0606 9.93944L15 12.8789L17.9394 9.93944C18.5254 9.3535 19.4746 9.3535 20.0606 9.93944C20.6465 10.5254 20.6465 11.4746 20.0606 12.0606L17.1211 14.9999L20.0606 17.9393Z" fill="#E2E2E2" />
	</svg>
  );

export default CloseIcon;
